import { useContext } from 'react';

import { LocaleContext, LocaleContextInterface } from '../context';

export default function useLocale(): LocaleContextInterface {
  return useContext(LocaleContext);
}
